export default __webpack_public_path__ + "static/evangelion-18eff54fe5026c5b1da98effd638b0fd.webp";